export default __webpack_public_path__ + "static/cap4-df4a2984cc82da531aa321dfba9676d1.png";